import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
import { SearchSummaryPropertiesType } from "@website/widget/search-summary/types";
import { FC } from "react";
export const SearchSummary: FC<Partial<SearchSummaryPropertiesType>> = properties => {
  const $ = _c(27);
  const {
    dateFrom,
    dateTo,
    detail,
    title,
    tripType,
    onClick,
    isHeadingSpan
  } = properties;
  const shouldBeSSR = !(dateFrom && dateTo);
  const t0 = `bg-dim-background text-on-surface-high-emphasis text-subtitle-2 flex w-max max-w-[1200px] items-center gap-2 rounded-full border px-4 max-md:w-full md:gap-0 md:px-0 md:pl-[2px] ${shouldBeSSR ? "border-secondary" : "border-outline-thin"}`;
  let t1;
  if ($[0] !== isHeadingSpan || $[1] !== title) {
    t1 = isHeadingSpan ? <span className="md:border-l-outline-thin max-md:text-body-2 truncate text-right max-md:mt-1.5 md:my-2 md:border-l md:px-4">{title}</span> : <h1 className="md:border-l-outline-thin max-md:text-body-2 truncate text-right max-md:mt-1.5 md:my-2 md:border-l md:px-4">{title}</h1>;
    $[0] = isHeadingSpan;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== tripType) {
    t2 = tripType && <div className="flex items-center md:hidden"><div>{tripType}</div><div className="whitespace-pre"> / </div></div>;
    $[3] = tripType;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== dateFrom || $[6] !== dateTo || $[7] !== shouldBeSSR) {
    t3 = <div className="md:border-l-outline-thin my-2 max-md:my-0 md:border-l md:px-4">{shouldBeSSR ? <span className="text-secondary">تعیین تاریخ</span> : <span>{dateFrom}{dateTo && <span>- {dateTo}</span>}</span>}</div>;
    $[5] = dateFrom;
    $[6] = dateTo;
    $[7] = shouldBeSSR;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== detail || $[10] !== shouldBeSSR) {
    t4 = Array.isArray(detail) && detail.length > 0 && !shouldBeSSR ? <><div className="whitespace-pre md:hidden">/ </div><div className="my-2 truncate max-md:my-0 md:px-4"><span className="md:hidden">{numberConvert(detail.join(" / "), {
            locale: "fa"
          })}</span><span className="hidden md:block">{numberConvert(detail.join("\u060C "), {
            locale: "fa"
          })}</span></div></> : <><div className="whitespace-pre md:hidden">/ </div><div className="text-secondary my-2 truncate max-md:my-0 md:px-4">تعیین تعداد مسافر</div></>;
    $[9] = detail;
    $[10] = shouldBeSSR;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className="max-md:text-on-surface-medium-emphasis max-md:text-overline flex items-center whitespace-pre max-md:mb-1.5 max-md:mt-1 max-md:font-medium max-md:leading-3">{t2}{t3}{t4}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t1 || $[17] !== t5) {
    t6 = <div className="flex w-full min-w-0 shrink max-md:flex-col">{t1}{t5}</div>;
    $[16] = t1;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const t7 = `flex size-6 shrink-0 items-center justify-center rounded-full text-2xl md:size-9 ${shouldBeSSR ? "" : "md:bg-primary text-on-surface-medium-emphasis md:text-on-color-high-emphasis"}`;
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <MaterialIcon name="search" />;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7) {
    t9 = <div className={t7}>{t8}</div>;
    $[20] = t7;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onClick || $[23] !== t0 || $[24] !== t6 || $[25] !== t9) {
    t10 = <button className={t0} onClick={onClick} type="button">{t6}{t9}</button>;
    $[22] = onClick;
    $[23] = t0;
    $[24] = t6;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};